<template>
    <v-card>
        <v-card-text class="text-center pa-7" v-if="!loaded">
            <v-progress-circular
                indeterminate
                color="indigo"
                class="ma-5"
            ></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
            <chart
                ref="chart"
                height="300"
                :options="options"
                :series="series"
            ></chart>
        </v-card-text>
    </v-card>
</template>

<script>
import ApexChartHelper from './ApexChartHelper'
import VueApexCharts from 'vue-apexcharts'

export default {
    props: ['resellerTypeRefer'],

    components: {
        chart: VueApexCharts,
    },

    data: () => {
        return {
            loaded: false,
            labels: [],
            series: [],
        }
    },

    watch: {
        resellerTypeRefer() {
            this.loaded = false
            this.fetchData().then(() => (this.loaded = true))
        },
    },

    computed: {
        helper() {
            return new ApexChartHelper()
        },

        options() {
            return {
                chart: {
                    type: 'area',
                },
                colors: ['#118eed', '#09ed8e', '#db1623', '#ffab02', '#c4c0c0'],
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: 'straight',
                },
                title: this.helper.title({ text: 'Faturado' }),
                xaxis: {
                    type: 'datetime',
                },
                tooltip: {
                    x: {
                        format: 'MM/yyyy',
                    },
                    y: {
                        formatter: value => {
                            return this.$n(value ? value : 0, 'currency')
                        },
                    },
                },
            }
        },
    },

    methods: {
        async fetchData() {
            const which =
                'which[]=charges.total&which[]=charges.paid&which[]=charges.overdue&which[]=charges.archived&which[]=discounts.total'
            let endpoint = '/dashboard/kpis/monthly?' + which

            if (this.resellerTypeRefer) {
                endpoint +=
                    '&aggregators[reseller_type_refer]=' +
                    this.resellerTypeRefer
            }

            let res = await this.$http.get(endpoint)
            this.dataHandler(res.data)
        },

        dataHandler(data) {
            this.series = []
            let charges = []
            let chargesWithDiscount = []
            let payments = []
            let overdue = []
            let discounts = []
            let archived = []

            this.labels = Object.keys(data)

            this.labels.forEach(element => {
                const chargeValue = data[element]['charges.total']
                    ? data[element]['charges.total']
                    : 0
                const paymentValue = data[element]['charges.paid']
                    ? data[element]['charges.paid']
                    : 0
                const overdueValue = data[element]['charges.overdue']
                    ? data[element]['charges.overdue']
                    : 0
                const discountValue = data[element]['discounts.total']
                    ? data[element]['discounts.total']
                    : 0
                const archivedValue = data[element]['charges.archived']
                    ? data[element]['charges.archived']
                    : 0

                charges.push({ x: element, y: chargeValue })
                chargesWithDiscount.push({
                    x: element,
                    y: chargeValue - discountValue,
                })
                payments.push({ x: element, y: paymentValue })
                overdue.push({ x: element, y: overdueValue })
                discounts.push({ x: element, y: discountValue })
                archived.push({ x: element, y: archivedValue })
            })

            this.series.push({ name: 'Total sem descontos', data: charges })
            this.series.push({
                name: 'Total com descontos',
                data: chargesWithDiscount,
            })
            this.series.push({ name: 'Recebido', data: payments })
            this.series.push({ name: 'Atrasado', data: overdue })
            this.series.push({ name: 'Descontos', data: discounts })
            this.series.push({ name: 'Arquivado', data: archived })
        },
    },

    created() {
        this.fetchData().then(() => (this.loaded = true))
    },
}
</script>

<style></style>
